import { Link } from "react-router-dom";

function DashboardCard({ card }) {
  const hasTitle = Boolean(card.title);
  const hasDescription = Boolean(card.description);
  const hasLink = Boolean(card.href);

  return (
    <article className="group flex min-h-[clamp(9.5rem,14vw,11.5rem)] flex-col items-center justify-center rounded-[0.5rem] border border-transparent bg-white px-[clamp(1rem,1.6vw,1.25rem)] py-[clamp(1rem,1.8vw,1.5rem)] text-center shadow-[0_3px_13px_rgba(15,23,42,0.16)] transition duration-200 ease-out hover:-translate-y-1 hover:border-[#b9d5ff] hover:shadow-[0_10px_24px_rgba(15,23,42,0.18)] focus-within:-translate-y-1 focus-within:border-[#0d73ff] focus-within:shadow-[0_0_0_3px_rgba(13,115,255,0.18),0_10px_24px_rgba(15,23,42,0.18)]">
      {hasTitle ? (
        <h2 className={`${hasDescription || hasLink ? "mb-[clamp(0.75rem,1.2vw,1rem)]" : "mb-0"} text-[clamp(1rem,1.2vw,1.27rem)] font-extrabold text-[#062f58]`}>
          {card.title}
        </h2>
      ) : null}

      {hasDescription ? (
        <p className={`${hasLink ? "mb-[clamp(1rem,1.4vw,1.25rem)]" : "mb-0"} w-full max-w-[clamp(13rem,18vw,16rem)] text-[clamp(0.8rem,1vw,1.04rem)] leading-[1.12] text-[#3f4751]`}>
          {card.description}
        </p>
      ) : null}

      {hasLink ? (
        <Link
          className="rounded-sm text-[clamp(0.9rem,1vw,1rem)] font-extrabold text-[#0d73ff] no-underline transition group-hover:text-[#005bd4] hover:underline hover:underline-offset-[5px] focus-visible:outline-none focus-visible:underline focus-visible:underline-offset-[5px]"
          to={card.href}
        >
          <span aria-hidden="true">&rarr;</span> Go
        </Link>
      ) : null}
    </article>
  );
}

export default DashboardCard;
